<template>
    <div class="wifiList">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>wifi管理</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="search">
            <span>SSID：</span>
            <el-input v-model="list.SSID" placeholder="请输入SSID"></el-input>
            <span>所在位置：</span>
            <el-input v-model="list.placeName" placeholder="请输入所在位置"></el-input>
            <el-button type="primary" @click="getCategroy()">查找</el-button>
            <el-button type="primary" @click="onAdd">添加</el-button>
        </div>
        <el-table :data="tableData" style="width: 100%" border>
            <el-table-column align="center" prop="wifiId" label="wifiId" width="width"></el-table-column>
            <el-table-column align="center" prop="SSID" label="SSID" width="width"></el-table-column>
            <el-table-column align="center" prop="placeName" label="所在位置" width="width"></el-table-column>
            <el-table-column align="center" prop="password" label="密码" width="width"></el-table-column>
            <el-table-column align="center" prop="regCount" label="注册人数" width="width"></el-table-column>
            <el-table-column align="center" prop="addMaster" label="创建人" width="width"></el-table-column>
            <el-table-column align="center" prop="addTime" label="创建时间" width="width"></el-table-column>
            <el-table-column align="center" prop="strStatus" label="状态" width="width"></el-table-column>
            <el-table-column align="center" label="操作" width="250">
                <template slot-scope="{ row }">
                    <el-button type="primary" size="mini" @click="$router.push('/vipList?id=' + row.wifiId)">查看注册人员</el-button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <el-dropdown>
                        <el-button size="mini" type="primary">
                            更多操作<i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item><span @click="onDelRow(row.wifiId, 1)" v-if="row.status === 2">启用</span></el-dropdown-item>
                            <el-dropdown-item><span @click="onDelRow(row.wifiId, 2)" v-if="row.status === 1" style="color:red;">禁用</span></el-dropdown-item>
                            <el-dropdown-item><span @click="onEdit(row)">编辑</span></el-dropdown-item>
                            <el-dropdown-item><span @click="onDel(row.wifiId)" style="color:red;">删除</span></el-dropdown-item>
                            <el-dropdown-item><span @click="creatCode(row.wifiId)">生成二维码</span></el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="list.currentPage" :page-sizes="[5, 10, 15, 20]" :page-size="list.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
        <!-- 添加一级分类 -->
        <el-dialog destroy-on-close :title="addOrEdit.wifiId === 0 ? '添加分类' : '编辑分类'" :visible.sync="addDialogVisible" width="30%" @close="onDiaLog">
            <el-form ref="form" label-width="80px">
                <el-form-item label="所在位置">
                    <el-input placeholder="请输入所在位置" v-model="addOrEdit.placeName"></el-input>
                </el-form-item>
                <el-form-item label="SSID">
                    <el-input placeholder="请输入SSID" v-model="addOrEdit.SSID"></el-input>
                </el-form-item>
                <el-form-item label="密码">
                    <el-input placeholder="请输入密码" v-model="addOrEdit.password"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="onEditCateOk">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="提示" :visible.sync="codeVisible" width="30%">
            <div class="inner_top">
                <el-input style="width:300px" v-model.trim="widthSize" placeholder="请输入生成的二维码大小"></el-input>

                <el-button type="primary" @click="generateQRcode">生成</el-button>
            </div>
            <div style="color:red">推荐宽度：280px-1280px</div>
            <el-image v-show="imgUrl" fit="fill" :src="imgUrl"></el-image>
            <span slot="footer" class="dialog-footer">
                <span>右键点击图片，点击另存为保存图片</span>
                <el-button @click="codeVisible = false">取 消</el-button>
                <el-button type="primary" @click="codeVisible = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import {
  wifiList,
  addWifi,
  wifiStatus,
  delWifi,
  wifiCode
} from "../../../api/tool";
export default {
  name: "wifiList",
  data() {
    return {
      codeVisible: false,
      addDialogVisible: false,
      tableData: [],
      list: {
        pageSize: 5,
        currentPage: 1,
        placeName: "",
        SSID: '',
        status: 0
      },
      pagination: {},
      addOrEdit: {
        wifiId: null,
        placeName: null,
        SSID: null,
        password: null,
      },
      wifiId: 0,
      widthSize: '',
      imgUrl: ''
    };
  },
  created() {
    this.getCategroy();
  },
  methods: {
    creatCode(id) {
      this.wifiId = id
      this.codeVisible = true
      this.imgUrl = ''
    },
    async generateQRcode() {
      this.imgUrl = ''
      if (!this.widthSize) {
        this.$message({ message: "请输入宽度", type: "warning" });
      } else {
        const { data } = await wifiCode({
          wifiId: this.wifiId,
          widthSize: this.widthSize
        })
        this.imgUrl = data.msg
        console.log(this.imgUrl);
      }

    },
    //删除
    onDelRow(wifiId, status) {
      this.$confirm("是否设置这条数据", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          const { data } = await wifiStatus({
            wifiId,
            status
          });
          if (data.code === 0) {
            this.$message({
              message: data.msg,
              type: "success"
            });
            this.getCategroy();
          } else {
            this.$message({
              message: data.msg,
              type: "error"
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    onDel(wifiId) {
      this.$confirm("是否删除这条数据", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          const { data } = await delWifi({
            wifiId
          });
          if (data.code === 0) {
            this.$message({
              message: data.msg,
              type: "success"
            });
            this.getCategroy();
          } else {
            this.$message({
              message: data.msg,
              type: "error"
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    onEdit(row) {
      this.addOrEdit.SSID = row.SSID;
      this.addOrEdit.wifiId = row.wifiId;
      this.addOrEdit.placeName = row.placeName;
      this.addOrEdit.password = row.password;
      this.addDialogVisible = true;
    },
    onDiaLog() {
      this.addOrEdit.SSID = null;
      this.addOrEdit.wifiId = null;
      this.addOrEdit.placeName = null;
      this.addOrEdit.password = null;
    },
    onAdd() {
      this.addDialogVisible = true;
      this.addOrEdit.wifiId = 0;
    },
    async getCategroy() {
      const { data } = await wifiList(this.list);
      if (data.code === 0) {
        data.list.map(item => {
          item.inputVisible = false;
        });
        this.tableData = data.list;
        this.pagination = data.pagination;
      } else {
        this.$message.error(data.msg);
      }
    },
    //添加一级分类
    async onEditCateOk() {
      // 1. 基础必填项校验
      if (!this.addOrEdit.placeName || !this.addOrEdit.SSID || !this.addOrEdit.password) {
        return this.$message({
          message: "请把数据填写完整！",
          type: "warning"
        });
      }

      // 2. WiFi密码专项校验
      const password = this.addOrEdit.password.trim(); // 去除首尾空格
      // 正则表达式：匹配任意中文字符（包括简体、繁体）
      const chineseReg = /[\u4e00-\u9fa5\u3400-\u4dbf\u{20000}-\u{2a6df}\u{2a700}-\u{2b73f}\u{2b740}-\u{2b81f}\u{2b820}-\u{2ceaf}\u{2ceb0}-\u{2ebe0}\u{2f800}-\u{2fa1f}]/u;

      // 校验长度（最少8位）
      if (password.length < 8) {
        return this.$message({
          message: "WiFi密码长度不能少于8位！",
          type: "warning"
        });
      }

      // 校验是否包含中文
      if (chineseReg.test(password)) {
        return this.$message({
          message: "WiFi密码不能包含中文字符！",
          type: "warning"
        });
      }

      // 3. 提交接口请求
      try {
        const { data } = await addWifi(this.addOrEdit);
        if (data.code == 0) {
          this.$message({
            message: data.msg,
            type: "success"
          });
          this.getCategroy();
        } else {
          this.$message({
            message: data.msg,
            type: "error"
          });
        }
      } catch (error) {
        // 增加接口请求异常捕获
        this.$message({
          message: "网络异常，操作失败！",
          type: "error"
        });
        console.error("WiFi添加/编辑失败：", error);
      }

      // 4. 重置表单和弹窗状态
      this.addDialogVisible = false;
      this.addOrEdit = {
        wifiId: null,
        placeName: null,
        SSID: null,
        password: null
      };
    },
    handleSizeChange(num) {
      this.list.pageSize = num;
      this.getCategroy();
    },
    handleCurrentChange(num) {
      this.list.currentPage = num;
      this.getCategroy();
    }
  }
};
</script>
<style lang="less" scoped>
.wifiList {
  .el-breadcrumb {
    height: 35px;
    border-bottom: 1px solid rgb(192, 191, 191);
  }
  .search {
    margin-top: 50px;
    .el-select {
      margin: 0 20px;
    }
    .select {
      margin: 0 10px;
    }
    .el-input {
      width: 200px;
      margin: 0 20px;
    }
  }
  .el-table {
    margin-top: 50px;
  }
  .el-pagination {
    float: right;
    margin-top: 50px;
  }
  /deep/.el-form {
    .el-form-item {
      .el-form-item__content {
        .elbtn {
          margin-left: 10px;
          background-color: unset;
          width: 110px;
          height: 110px;
          text-align: center;
          line-height: 110px;
          color: #000;
          border: 1px solid #ccc;
        }
        display: flex;
        .img {
          position: relative;
          margin: 0 20px;
          height: 100px;
          width: 100px;
          img {
            height: 100px;
            width: 100px;
            border: 1px solid #c0ccda;
          }
          div {
            position: absolute;
            top: 0;
            right: 5px;
            height: 10px;
            width: 10px;
            z-index: 100;
          }
        }
        .addImg {
          display: inline-block;
          width: 100px;
          height: 100px;
          border: 1px dashed #c0ccda;
          text-align: center;
          line-height: 100px;
          cursor: pointer;
          i {
            width: 50px;
            height: 50px;
            font-size: 20px;
            color: #c0ccda;
          }
        }
        span {
          margin-left: 30px;
          color: red;
        }
      }
    }
  }
}
</style>